import { ProductGalleryItemInterface } from 'types/types';
import { css } from '@emotion/react';
import resourceUrl from '../../../../../util/make-url';
import PlayIcon from './play-icon.png';
import preventDefaultAction from '../../../../../util/prevent-default-action';
import { zIndices } from 'constants/z-indices';

const Thumbnail = ({
  isActive = false,
  item: { file },
  setActive,
  isVideo,
  onClick,
}: {
  isActive?: boolean;
  item: ProductGalleryItemInterface;
  setActive: () => void;
  isVideo: boolean;
  onClick?: () => void;
}) => {
  const src = resourceUrl(file.url, {
    width: 200,
    height: 200,
    bg: 'fff',
    fit: 'fill',
  });

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={setActive}
      onKeyPress={setActive}
      tabIndex={-1}
      onContextMenu={preventDefaultAction}
      css={theme => css`
        border: 3px solid white;
        background-color: ${theme.colors.lightishGrey};
        outline: none;
        position: relative;
        label: ${file.id};
        background-image: url('${src}');
        background-size: cover;
        background-position: center;
        background-color: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: ${theme.shadows.cards};
        height: auto;
        width: 100%;
        aspect-ratio: 1 / 1;
        margin: 0 5px;
        display: block;
        &:after {
          content: '';
          display: block;
          padding-bottom: 100%;
        }
        ${isActive &&
        css`
          background-color: ${theme.colors.darkishGrey};
          @media ${theme.mediaQueries.tabletUp} {
            background-color: white;
            border-color: ${theme.colors.primary};
          }
        `}
      `}
    >
      {isVideo && (
        <img
          src={PlayIcon.src}
          alt="play Icon"
          css={css`
            display: block;
            position: absolute;
            z-index: ${zIndices.CAROUSEL_THUMBNAIL};
            top: calc(50% - 11px);
            left: calc(50% - 11px);
            width: 22px;
            height: 22px;
          `}
        />
      )}

      {/* right-click save blocker */}
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        `}
      />
    </button>
  );
};

export default Thumbnail;
